import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { CloudflareConnector } from '../../connector';

export const WafService = IntegrationService.make({
  connector: CloudflareConnector,
  name: Integration_Service_Names_Enum.Waf,
});
